import { AuthProtectedRoute } from "common/components/AuthProtectedRoute";
import { CreateSalePage, Landing, Users } from "pages";
import Login from "pages/authentication/Login";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { AuthenticationRouter } from "./pages/authentication/Router";


export const AppRouter = () => {
  return (
    <Router>
      <Switch>
        <Route path="/authentication">
          <AuthenticationRouter />
        </Route>
        <AuthProtectedRoute path="/landing" component={Landing} />
        <AuthProtectedRoute path="/assets" component={CreateSalePage} />
        <AuthProtectedRoute path="/users" component={Users} />
        <Route path="/">
          <Login />
        </Route>
      </Switch>
    </Router>
  );
};
